import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "common/api/BaseQuery";
import {
  ContactFeedbackJson,
  ContactFeedbackPostJson,
  ContactSupportJson,
  ContactSupportPostJson,
  NewsLetterJson,
  NewsLetterPostJson,
  SenderNewsLetterJson,
  SenderNewsLetterPostJson,
  VerifyNewsLetterPostJson,
} from "../types/newsletter.type";
import Nteam from "common/constants/Nteam";

export const newsletterApi = createApi({
  reducerPath: "newsletterApi",
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    // Api Public
    postNewsLetter: builder.mutation<any, NewsLetterPostJson>({
      query: (body: NewsLetterPostJson) => {
        return {
          url: "customers/public/newsletter",
          method: "post",
          body: {
            ...body,
          },
        };
      },
    }),

    postSenderNewsLetter: builder.mutation<any, SenderNewsLetterPostJson>({
      query: (body: SenderNewsLetterPostJson) => {
        return {
          url: "customers/public/sendernewsletter",
          method: "post",
          body: {
            ...body,
          },
        };
      },
    }),

    postVerifyNewsLetter: builder.mutation<any, VerifyNewsLetterPostJson>({
      query: (body: VerifyNewsLetterPostJson) => {
        return {
          url: "customers/public/verifynewsletter",
          method: "post",
          params: {},
          body: {
            ...body,
          },
        };
      },
    }),

    postContactFeedback: builder.mutation<
      ContactFeedbackJson,
      ContactFeedbackPostJson
    >({
      query: (body: ContactFeedbackPostJson) => {
        return {
          url: "customers/public/contact/feedback",
          method: "post",
          body: {
            ...body,
          },
        };
      },
    }),

    postContactSupport: builder.mutation<
      ContactSupportJson,
      ContactSupportPostJson
    >({
      query: (body: ContactSupportPostJson) => {
        return {
          url: "customers/public/contact/support",
          method: "post",
          body: {
            ...body,
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  usePostVerifyNewsLetterMutation,
  usePostSenderNewsLetterMutation,
  usePostNewsLetterMutation,
  usePostContactFeedbackMutation,
  usePostContactSupportMutation,
} = newsletterApi;
